import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import LogoVoala from 'assets/images/logo/LogoVoala';
import { RoutesBase } from 'routes/constants-routes';
import HeaderLogin from './HeaderLogin';

type Props = {
  cleanHome: () => void;
};

const HeaderMenuDesktop: React.FC<Props> = props => {
  const { cleanHome } = props;
  return (
    <>
      <div className="header-links desktop">
        <Link className="navbar-brand" to="/" onClick={() => cleanHome()}>
          <LogoVoala
            width="100px"
            height="auto"
            viewBox="75 0 140 70"
            fill="#FF5A00"
            className="link"
          />
        </Link>
      </div>
      <ul className="navbar-nav ml-md-auto text-center desktop">
        <li className="nav-item">
          <NavLink
            activeClassName="active"
            className="nav-link new-link"
            to={`/${RoutesBase.recommend.home}`}
          >
            Voalá Recomenda
          </NavLink>
        </li>
        <HeaderLogin />
      </ul>
    </>
  );
};

export default React.memo(HeaderMenuDesktop);
